/**
 * Core API - Factories
 *
 * Database operations for factories (physical locations within a tenant).
 */

import { supabase } from '@/integrations/supabase/client';

export interface Factory {
  id: string;
  tenant_id: string;
  name: string;
  code: string;
  address: string | null;
  timezone: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}


export async function fetchFactoryById(factoryId: string): Promise<Factory | null> {
  const { data, error } = await supabase
    .schema('core')
    .from('factories')
    .select('*')
    .eq('id', factoryId)
    .maybeSingle();

  if (error) throw error;
  return data as Factory | null;
}

export async function fetchAllActiveFactories(): Promise<Factory[]> {
  const { data, error } = await supabase
    .schema('core')
    .from('factories')
    .select('id, name, code, tenant_id')
    .eq('is_active', true)
    .order('name');

  if (error) throw error;
  return data as Factory[];
}

export async function fetchFactoriesByTenantId(tenantId: string): Promise<Factory[]> {
  const { data, error } = await supabase
    .schema('core')
    .from('factories')
    .select('*')
    .eq('tenant_id', tenantId)
    .eq('is_active', true)
    .order('name');

  if (error) throw error;
  return data as Factory[];
}
